/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {ComponentDispatch} from '@app/lib/ComponentDispatch';
import type {InboxTab} from '@app/stores/InboxStore';
import InboxStore from '@app/stores/InboxStore';
import MobileLayoutStore from '@app/stores/MobileLayoutStore';
import PopoutStore from '@app/stores/PopoutStore';

export function setTab(tab: InboxTab): void {
	InboxStore.setTab(tab);
}

export function revealBookmarksPopoutForFirstSave(): boolean {
	if (MobileLayoutStore.isMobileLayout()) {
		return false;
	}

	if (!InboxStore.shouldAutoOpenBookmarksPopoutForFirstSave()) {
		return false;
	}

	const isInboxOpen = PopoutStore.isOpen('inbox');
	const canOpenInbox = isInboxOpen || ComponentDispatch.hasSubscribers('INBOX_OPEN');
	if (!canOpenInbox) {
		return false;
	}

	InboxStore.setTab('bookmarks');
	if (!isInboxOpen) {
		ComponentDispatch.dispatch('INBOX_OPEN');
	}
	InboxStore.markBookmarksPopoutAutoOpenedForFirstSave();
	return true;
}
